import React from 'react';
import { Link } from 'react-router-dom';
import { contactConfig } from '../../config/contact.config';
import logo2 from '../../assets/akte.jpeg';
import './Footer.css';

const Footer: React.FC = () => {
    return (
        <footer className="footer">
            <div className="footer-content">
                <div className="footer-logo">
                    <img src={logo2} alt="OK Immobilier" className="logo-footer" />
                </div>

                <div className="footer-contact">
                    <a href={`tel:${contactConfig.phone.replace(/\s/g, '')}`} className="contact-item">
                        <span className="contact-icon">📞</span>
                        <span>{contactConfig.phone}</span>
                    </a>
                    <a href={`tel:${contactConfig.phone2.replace(/\s/g, '')}`} className="contact-item">
                        <span className="contact-icon">📞</span>
                        <span>{contactConfig.phone2}</span>
                    </a>
                    <a href={`mailto:${contactConfig.email}`} className="contact-item">
                        <span className="contact-icon">✉️</span>
                        <span>{contactConfig.email}</span>
                    </a>
                    <a
                        href={contactConfig.mapUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="contact-item"
                    >
                        <span className="contact-icon">📍</span>
                        <span>{contactConfig.address}</span>
                    </a>
                </div>
            </div>

            <div className="footer-legal">
                <Link to="/mentions-legales" className="legal-link">
                    {contactConfig.legalMentionsText}
                </Link>
            </div>
        </footer>
    );
};

export default Footer;
